import React from 'react';
import BaseIcon from './BaseIcon';

interface MapPinIconProps {
  className?: string;
}

const MapPinIcon: React.FC<MapPinIconProps> = ({ className }) => (
  <BaseIcon className={className}>
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
    <circle cx="12" cy="10" r="3"></circle>
  </BaseIcon>
);

export default MapPinIcon;
